import instance from 'utils/apiCalls';
import { APPLICATION_PREVIEW_URLS } from './applicationPreviewUrls';
import {
  ApplicationStatus,
  IResponsiblePerson
} from '../../../types/interface';

export const changeStatusOfApplication =
  (
    data: { application_status: ApplicationStatus; comments: string },
    id: string
  ) =>
  async () => {
    try {
      const response = await instance.put(
        APPLICATION_PREVIEW_URLS.CHANGE_APPLICATION_STATUS.replace(
          ':application_id',
          id
        ),
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

export const getOverviewData = (id: string) => async () => {
  try {
    const response = await instance.get(
      APPLICATION_PREVIEW_URLS.GET_SINGLE_APPLICATION_OVERVIEW.replace(
        ':application_id',
        id
      )
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getApplicationTypeOptionAll = (params?: any) => async () => {
  const response = await instance.get(
    APPLICATION_PREVIEW_URLS.APPLICATION_REQ_OPTION_ALL,
    {
      params: params
    }
  );
  return response;
};

export const updateResponsiblePerson =
  (data: IResponsiblePerson) => async () => {
    const response = await instance.put(
      APPLICATION_PREVIEW_URLS.UPDATE_RESPONSIBLE_PERSON,
      data
    );
    return response;
  };
